import React from 'react';
import { Redirect } from 'react-router-dom';

class URLShowcase extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      urlList: [''],
      loading: true
    }
  }

  getData() {
    const { id } = this.props.match.params

    fetch(`https://mergeurl1.azurewebsites.net/v1/${id}`, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    })
    .then(response => response.json())
    .then(response => {
      this.setState({
        urlList: response
    })
      let myList = this.state.urlList
      if (this.state.urlList !== "Failed") {
        for (let i = 0; i < myList.length; i++) {
          if (myList[i].substring(0, 8) === "https://" || myList[i].substring(0, 7) === "http://") {
            continue;
          }
          myList[i] = "http://" + myList[i];
        }
        this.setState({
          urlList: myList,
          loading: false
        });
      }
    });
  }

  componentDidMount() {
    this.getData();
  }


  render() {
    if (this.state.urlList === "Failed") {
      return (
        <Redirect to="/*" />
      )
    }
    return (
      <section className="hero-section center-content">
        <title>MergeURL - Associated Links</title>
        <div className="container-sm">
          <div className="hero-inner section-inner">
            <div className="hero-content">
              <h2 className="mt-32 mb-32 reveal-from-bottom" data-reveal-delay="200">
                Links associated with this <span className="text-color-primary">MergeURL</span>
              </h2>
              <div className="container-xs">
                {this.state.loading ? (
                  <h5 className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                    We're loading links associated with this MergeURL. It may take some time.
                  </h5>
                ) : (
                  <h5 className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                    Click on the links to visit them.
                  </h5>
                )}
                <div className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="600">
                  {this.state.urlList[0] !== undefined && !this.state.loading ? (
                    <div className="mb-16 showcase">
                      <p className="mt-16">
                        <a href={this.state.urlList[0]} target="_blank" rel="noopener noreferrer">
                          <span className="text-color-primary">{this.state.urlList[0]}</span>
                        </a>
                      </p>
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {this.state.urlList[1] !== undefined ? (
                    <div className="mb-16 showcase">
                      <p className="mt-16">
                        <a href={this.state.urlList[1]} target="_blank" rel="noopener noreferrer">
                          <span className="text-color-primary">{this.state.urlList[1]}</span>
                        </a>
                      </p>
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {this.state.urlList[2] !== undefined ? (
                    <div className="mb-16 showcase">
                      <p className="mt-16">
                        <a href={this.state.urlList[2]} target="_blank" rel="noopener noreferrer">
                          <span className="text-color-primary">{this.state.urlList[2]}</span>
                        </a>
                      </p>
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {this.state.urlList[3] !== undefined ? (
                    <div className="mb-16 showcase">
                      <p className="mt-16">
                        <a href={this.state.urlList[3]} target="_blank" rel="noopener noreferrer">
                          <span className="text-color-primary">{this.state.urlList[3]}</span>
                        </a>
                      </p>
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {this.state.urlList[4] !== undefined ? (
                    <div className="mb-16 showcase">
                      <p className="mt-16">
                        <a href={this.state.urlList[4]} target="_blank" rel="noopener noreferrer">
                          <span className="text-color-primary">{this.state.urlList[4]}</span>
                        </a>
                      </p>
                    </div>
                  ) : (
                    <span></span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default URLShowcase;
